import React from 'react';
import { observer } from 'mobx-react-lite';
import { freeBetStore } from '@pascal/pascal-core';
import { GameBetButtons, PrizeTicker, WheelLightning, Wheels, WinPopup } from '../../../components';
import triangleImg from '../../../assets/images/triangle.png';
import { candyDataStore } from '../../../store';

export const GameMainTop = observer(() => {
  const { activeFreeBet } = freeBetStore;
  const { zoomAnim, multiplierData } = candyDataStore;
  return (
    <div
      className={`dream-wheel-top  ${
        multiplierData?.multiplierCandy ? `type-${multiplierData?.multiplierCandy} active` : ''
      }`}
    >
      <div className='dream-wheel-top-wrp'>
        <div className='dr-wh-pr-wrapper'>
          <div className='dr-wh-pr-holder'>
            <PrizeTicker />
          </div>
        </div>
        <div
          className='dream-wheel-top-circle'
          style={{
            animationDelay: zoomAnim?.animationDelay,
            animationDuration: zoomAnim?.animationDuration,
          }}
        >
          <div className='dream-wheel-top-circle-ins'>
            <div className='wheel-triangle'>
              <img src={triangleImg} alt='triangle' />
            </div>
            <WheelLightning />
          </div>
          <Wheels />
          <WinPopup />
        </div>
      </div>
      <span className='image-preload type-1' />
      <span className='image-preload type-2' />
      <span className='image-preload type-3' />
      <span className='image-preload type-4' />
      <GameBetButtons candyType={multiplierData?.multiplierCandy} activeFreeBet={activeFreeBet} />
    </div>
  );
});
